module.exports = __webpack_public_path__ + "static/media/virtual-showroom.d911b51e.jpg";